module.exports = __webpack_public_path__ + "static/media/bet-logo-sabah88.ed983eeb.png";